export const cssColourToHex = (value, fallback = "#000000") => {
  const colour = String(value || "").trim();
  if (/^#[0-9a-f]{6}$/i.test(colour)) return colour.toLowerCase();
  if (/^#[0-9a-f]{3}$/i.test(colour)) {
    return `#${colour
      .slice(1)
      .split("")
      .map((character) => character + character)
      .join("")}`.toLowerCase();
  }
  const rgb = colour.match(
    /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})/i,
  );
  if (!rgb || (colour.startsWith("rgba") && /,\s*0(?:\.0+)?\s*\)$/.test(colour))) {
    return fallback;
  }
  return `#${rgb
    .slice(1, 4)
    .map((part) =>
      Math.max(0, Math.min(255, Number(part))).toString(16).padStart(2, "0"),
    )
    .join("")}`;
};

export const captureEditorRange = (editor) => {
  const selection = window.getSelection();
  if (!editor || !selection || !selection.rangeCount) return null;
  const range = selection.getRangeAt(0);
  if (!editor.contains(range.commonAncestorContainer)) return null;
  return range.cloneRange();
};

export const restoreEditorRange = (editor, savedRange) => {
  if (!editor || !savedRange) return null;
  try {
    if (!editor.contains(savedRange.commonAncestorContainer)) return null;
    editor.focus({ preventScroll: true });
    const selection = window.getSelection();
    if (!selection) return null;
    const range = savedRange.cloneRange();
    selection.removeAllRanges();
    selection.addRange(range);
    return range;
  } catch (_error) {
    return null;
  }
};

